import {useParams} from 'react-router-dom';
import styled from "styled-components";
import Main from '../../components/main';
import TopBar from '../../components/top_bar';
import {useBottomBar} from "../../app_context";
import {useBaseCommunity} from '../../store';
import TopHeadroom from "../../components/top_headroom";
import NavLink from "../../components/nav_link";

const FeedWrapper = styled.div`
  margin-top: 12px;
  background-color: ${({theme}) => theme.color.name === 'dark' ? `transparent` : '#fff'};`;
const Feed = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
`;
const Logo = styled.div`
width: 42px;
height: 42px;
img {
  border-radius: 50%;
}`;
const Details = styled.div`
margin-left: 12px;`;
const Heading = styled.div`
font-weight: 600;
font-size: 16px;`;
const FeedInfo = styled.div`
padding: 16px 16px 8px 16px;`;
const FeedTitle = styled.div`
font-size: 19px;
font-weight: 600;`;
const FeedDescription = styled.div`
font-size: 15px;`;

const SUGGESTED_FEEDS = [
    {
        name: 'Recommended',
        id: 1,
    },
    {
        name: 'All',
        id: 2,
    },
    {
        name: 'Memes',
        id: 4,
    },
    {
        name: 'COVID',
        id: 43,
    },
    {
        name: 'Discussion',
        id: 5,
    },
    {
        name: 'News',
        id: 6,
    },
    {
        name: 'Crypto',
        id: 14,
    },
    {
        name: 'Hobbies',
        id: 7,
    },
    {
        name: 'Gaming',
        id: 8,
    },
    {
        name: 'Technology',
        id: 17,
    },
    {
        name: 'Animals',
        id: 9,
    },
    {
        name: 'Videos',
        id: 19,
    },
    {
        name: 'Finance',
        id: 10,
    },
    {
        name: 'Conspiracies',
        id: 11,
    },
    {
        name: 'Sports',
        id: 20,
    },
    {
        name: 'Entertainment',
        id: 12,
    },
    {
        name: 'Politics',
        id: 13,
    },
    {
        name: 'Censorship',
        id: 15,
    },
    {
        name: 'Privacy',
        id: 18,
    },
    {
        name: 'Streaming',
        id: 16,
    },
];


const Feeds = ({}) => {
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    useBottomBar();

    return (
        <>
            <TopBar search community={community} sidebar settings />
            <Main>
                <FeedWrapper>
                    <FeedInfo>
                        <FeedTitle>Explore Feeds</FeedTitle>
                        <FeedDescription>Feeds are collections of communities</FeedDescription>
                    </FeedInfo>
                    {SUGGESTED_FEEDS?.map((suggestedFeed) => (
                        <NavLink key={suggestedFeed.id} href={`/feed/${suggestedFeed.id}/${suggestedFeed.name.toLowerCase()}`} react_route>
                            <Feed key={suggestedFeed.id}>
                                <Logo>
                                    <img src={`https://media.scored.co/feed-icons/feed_${suggestedFeed.name.toLowerCase()}_42.png?q=2`} />
                                </Logo>
                                <Details>
                                    <Heading>{suggestedFeed.name}</Heading>
                                </Details>
                            </Feed>
                        </NavLink>
                    ))}
                </FeedWrapper>
            </Main>
        </>
    );
};

export default Feeds;
